import * as React from 'react';
import {
  List,
  DatagridConfigurable,
  TextField,
  EditButton,
  NumberInput,
  SelectColumnsButton,
  TopToolbar,
  FilterButton,
  CreateButton,
  DateInput, DateField,
  useLocaleState, NumberField
} from "react-admin";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const filters = [
    <NumberInput key={0} source="id" label="id" min={1} />,
    <DateInput key={3} source="createdAt#$gte" label="Start Created At" />,
    <DateInput key={4} source="createdAt#$lte" label="End Created At" />,
];

export const CarTuningList = () => {
  const [locale] = useLocaleState();

  return (
    <List
      filters={filters}
      sort={{ field: 'position', order: 'ASC' }}
      actions={<ListActions />}
    >
      <DatagridConfigurable rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />

        <TextField source={`title.${locale}`} />

        <DateField source="createdAt" showTime locales="lv-LV" />
        <NumberField source={`position`} />
        <EditButton />
      </DatagridConfigurable>
    </List>
  )
};
